"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findById = void 0;
const ramda_1 = require("ramda");
/**
 * Returns the element in the array with the given id.
 *
 * @param items - The array of items to search.
 * @param id - The id of the item to search for.
 * @returns The item with the given id, or undefined if not found.
 *
 * @public
 *
 * @example
 * Here's a simple example:
 * ```ts
 * const result = getById([{id: 'foo'}, {id: 'bar'}], 'foo');
 * ```
 */
function findById(items, id) {
    return (0, ramda_1.find)((0, ramda_1.propEq)('id', id))(items);
}
exports.findById = findById;
//# sourceMappingURL=find-by-id.js.map